import VideoBox from "app/appComponents/videobox/VideoBox.react";
import React from "react";
import ImageGroup from "./ImageGroup.react";

export default class HeaderImage extends React.Component {
    render() {
        let componentStyles = {
            default: {
                height: "100%",
                pointerEvents: "none",
            },
            grid: {
                height: "100%",
                pointerEvents: "none",
            },
        };
        return (
            <div className="relativeDiv">
                {this.props.data.image != null &&
                    this.props.data.image.indexOf("default") === -1 && (
                        <ImageGroup
                            {...this.props}
                            style={componentStyles[this.props.layout]}
                            keyName={"image-" + this.props.slideId}
                            size="medium"
                            images={[this.props.data.image]}
                            animation="transition.expandIn,300,100"
                        />
                    )}
                {this.props.data.video != null && (
                    <VideoBox url={this.props.data.video} autoplay={true} />
                )}
            </div>
        );
    }
}
